import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/backlog-helper.png'


const _hoisted_1 = { class: "backlog" }
const _hoisted_2 = {
  key: 0,
  class: "backlog-helper"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Create tasks and drag them"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" to your daily focus")
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DailySyncTaskList = _resolveComponent("DailySyncTaskList")!
  const _component_AppLoadingIcon = _resolveComponent("AppLoadingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.backlogLoaded)
      ? (_openBlock(), _createBlock(_component_DailySyncTaskList, {
          key: 0,
          modelValue: _ctx.backlog,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.backlog) = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateBacklog()))
          ],
          group: "my-tasks",
          isBacklog: true,
          onDelete: _ctx.onDeleteTask,
          class: _normalizeClass({ 'daily-sync-list-saving': _ctx.isSaving })
        }, null, 8, ["modelValue", "onDelete", "class"]))
      : (_openBlock(), _createBlock(_component_AppLoadingIcon, { key: 1 })),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.backlogLoaded && _ctx.backlog.length < 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}